// URL-scheme allowlist for any user-controlled URL we feed into <a href={…}>
// or window.open/location. SECURITY_AUDIT H-1 + C-1.
//
// Returns the URL string if its scheme is safe to navigate, else returns '#'.
// Safe schemes:
//   http:, https:       — normal web links
//   mailto:, tel:       — useful, can't run JS
//   /…, #               — same-origin relative paths and hash links
// Rejects: javascript:, data:, vbscript:, file:, blob:, view-source:, and
// anything else exotic — including protocol-relative `//evil.com`, which the
// browser resolves to `https://evil.com` and would otherwise sneak past a
// naive "starts with /" check.

export function safeUrl(u) {
  const s = String(u == null ? '' : u).trim();
  if (s === '') return '#';
  if (/^(?:https?:|mailto:|tel:|\/(?!\/)|#)/i.test(s)) return s;
  return '#';
}

export default safeUrl;
